<template>
  <div>

    <legend>Communities</legend>
    <div class="row">
      <div class="form-group col-sm-8 col-md-2">
        <div class="has-feedback">
          <input class="search-input form-control" v-model="search" style="border-radius: 1rem; background-color: white;"
            placeholder="Search" />
        </div>
      </div>
      <div class="form-group col-sm-4 col-md-2">
        <div class="input-group">
          <input type="checkbox" id="include-withdrawn" v-model="onlyCommunities" @change="addSearchCriteria()" />
          <label for="include-withdrawn">No Projects</label>
        </div>
      </div>
    </div>

    <dl class="dashboard-dl">
      <div class="container-fluid">
        <div v-for="item in items" :key="item.Id">
          <div class="row">
            <div class="col-sm-12">
              <a :href="item.CommunityUrl">{{ item.Name }}</a>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading">
        <amenity-manatee-loading></amenity-manatee-loading>
      </div>
      <div v-else>
        <div v-if="reachedTheEnd">
          All Loaded
        </div>
        <div v-else>
          <button @click="fetchData">Load More</button>
        </div>
      </div>
    </dl>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      items: [],
      page: 1,
      additionalSearchQuery: "",
      pageCount: 0,
      loading: false,
      search: null,
      onlyCommunities: false,
    };
  },
  computed: {
    reachedTheEnd() {
      console.log(this.page > this.pageCount)
      return this.page > this.pageCount;
    }
  },
  watch: {
    search: _.debounce(
      function () {

        this.addSearchCriteria();
      },
      380,
      {
        trailing: true,
      }
    )
  },
  methods: {
    fetchData() {
      if (this.loading) return;
      this.loading = true;
      var url = "/core/community" + `?page=${this.page}&onlyCommunities=${this.onlyCommunities}`;
      console.log(this.page);
      if (this.additionalSearchQuery) {
        url += "&" + this.additionalSearchQuery;
      };
      console.log(url);
      axios.get(url)
        .then((response) => {
          console.log(response.data);
          this.items = this.items.concat(response.data.data);
          console.log(this.page);
          this.page++;
          console.log(this.page);
          this.pageCount = response.data.meta.last_page;
          console.log(this.pageCount);
          console.log(response.data.meta.last_page)
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    addSearchCriteria() {
      if (typeof this.search === "string" && this.search.length > 0) {
        this.additionalSearchQuery = "q=" + this.search;
      }
      else {
        this.additionalSearchQuery = "";
      }
      this.items = [];
      this.page = 1;
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
    window.addEventListener('scroll', () => {
      if ((window.innerHeight + window.scrollY) + 10 >= document.body.offsetHeight) {
        console.log('bottom of the page');
        if (this.reachedTheEnd) return;
        this.fetchData();
      }
    });
  }
};
</script>